<script setup lang="ts">
import type {SolutionsBlock} from '~/types/legacy'
import type {Populated} from '~/types/populated'

const props = defineProps<{
  data: Populated<SolutionsBlock>
}>()
</script>

<template>
  <div class="flex w-full flex-col items-center justify-between gap-6 md:flex-row md:gap-8">
    <div class="flex flex-col items-center text-center md:w-2/3 md:items-start md:text-left">
      <Heading class="mb-2 text-xl" as="h2" size="caption">
        {{ data.eyebrow }}
      </Heading>
      <Heading class="w-full text-2xl md:w-auto" as="h3" size="medium">
        {{ data.title }}
      </Heading>
    </div>
    <Paragraph size="normal" weight="normal" as="p" class="w-full text-center md:w-5/12 md:text-left">
      {{ data.description }}
    </Paragraph>
  </div>
</template>
